"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberFormatRoundedTwo = exports.numberFormatRoundedOne = exports.numberFormat = exports.NL_TIMEZONE = void 0;
exports.changeLocale = changeLocale;
exports.formatAsCurrency = formatAsCurrency;
exports.formatAsDate = formatAsDate;
exports.formatAsNumber = formatAsNumber;
exports.formatAsNumeral = formatAsNumeral;
exports.formatAsDistance = formatAsDistance;
exports.formatAsEmission = formatAsEmission;
exports.formatAsPercentage = formatAsPercentage;
exports.formatAsIban = formatAsIban;
/* eslint-disable import/namespace */
/* eslint-disable import/no-unresolved */
const common_utilities_1 = require("@cp-shared-14/common-utilities");
const moment = __importStar(require("moment-timezone"));
require("moment/locale/nl");
require("numeral/locales/nl-nl");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const numeral = require("numeral");
// Check out https://momentjs.com/timezone/
exports.NL_TIMEZONE = "Europe/Amsterdam";
moment.tz.setDefault(exports.NL_TIMEZONE);
// TODO Check the format definitions
const locale = "nl";
exports.numberFormat = "0,0";
exports.numberFormatRoundedOne = "0,0.0";
exports.numberFormatRoundedTwo = "0,0.00";
const numeralFormat = "0o";
const currencyFormat = "0,0.00";
const longDateFormat = "DD-MM-YYYY";
function changeLocale(locale) {
    moment.locale(locale);
    numeral.locale(locale === "nl" ? "nl-nl" : locale);
}
changeLocale(locale);
function formatAsCurrency(value) {
    return typeof value === "number"
        ? `€ ${numeral(value).format(currencyFormat)}`
        : "";
}
function formatAsDate(date) {
    if (!date)
        return "";
    return (0, common_utilities_1.formatCpDate)(date).format(longDateFormat);
}
function formatAsNumber(value, format = exports.numberFormat) {
    return typeof value === "number" ? numeral(value).format(format) : "";
}
function formatAsNumeral(value) {
    return typeof value === "number" ? numeral(value).format(numeralFormat) : "";
}
function formatAsDistance(value) {
    return typeof value === "number" ? numeral(value).format(exports.numberFormat) : "";
}
function formatAsEmission(value) {
    return typeof value === "number"
        ? `${numeral(value).format(exports.numberFormat)} g/km`
        : "";
}
function formatAsPercentage(value) {
    return typeof value === "number"
        ? `${numeral(value).format(exports.numberFormatRoundedTwo)} %`
        : "";
}
function formatAsIban(iban) {
    return (iban
        ?.replace(/[^\dA-Z]/g, "")
        .replace(/(.{4})/g, "$1 ")
        .trim() ?? "");
}
//# sourceMappingURL=formatters.js.map